module.exports = __webpack_public_path__ + "static/2022_L1_Collective_Bargaining_Agreement-04b6886fc521b63e4488ca193362a430.pdf";